export default __webpack_public_path__ + "static/media/add-card.aee74b17.svg";